// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api_url: 'https://amapi-dev.astormueller.com/returns_app',
  user: "returns_app",
  pass: "YqP3q8SPXrYCDPzFQClX",
  dhlHash: '18d7710128aa44d007e89f41a97277d43818327ac368a628f3f3f8397a7a6883',
  appVersion: require('../../package.json').buildNumber + '-dev',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
